module.exports = __webpack_public_path__ + "static/media/deploydog.cb3b9ba1.svg";